import React, { ReactElement } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory, History } from 'history';

import { SnapButton } from '@/components/generic/SnapButton';
import AuthProvider from '@/hooks/useAuth';
import { store } from '@/store';

import { Content } from './Content';

import '@gafe/common-ui/styles.css';
import 'styles/index.scss';
import styles from './RootModule.module.scss';

// TODO: Remove once Navigation class was removed and change Router to BrowserRouter
export const history: History = createBrowserHistory();

export const RootModule = (): ReactElement => (
  <Router history={history}>
    <Provider store={store}>
      <AuthProvider>
        <div className={styles.container}>
          <Content />
        </div>
        <SnapButton />
      </AuthProvider>
    </Provider>
  </Router>
);
